import React from "react";

const Footer = () => {
  return <footer>Shine &copy; 2023</footer>;
};

export default Footer;
